import type { RoutePath } from '#routes.js';

import { cn } from '@elara/client-core/lib/utils';

import { Link } from '#views/Router.js';

interface BreadcrumbItem {
  label: string;
  to?: RoutePath;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  className?: string;
}

export function Breadcrumbs({ items, className }: BreadcrumbsProps) {
  return (
    <nav aria-label="Breadcrumb" className={cn('flex items-center gap-2 text-sm text-muted-foreground', className)}>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={index} className="flex items-center gap-2">
            {index > 0 && <span className="text-muted-foreground/50">/</span>}
            {item.to && !isLast && (
              <Link to={item.to} className="hover:text-foreground transition-colors">
                {item.label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
